export default __webpack_public_path__ + "static/media/2-Login.d06b0839.jpeg";